import React, { useCallback, useRef, useState } from "react";
import { Popup } from "devextreme-react/popup";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { useDispatch, useSelector } from "react-redux";
import { getUIProperty, setUIProperty } from "../../redux/slices/uiSlice";
import { ToolbarItem } from "devextreme-react/data-grid";
import { downloadPdf } from "../../utils/general";

const PdfModal = () => {
  const dispatch = useDispatch();

  const pdfUrl = useSelector((state) => getUIProperty(state, "pdfUrl"));
  const fileName = useSelector((state) => getUIProperty(state, "fileName"));

  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [dimensions, setDimensions] = useState({
    height: "100%",
    width: "100%",
  });
  const canvasRef = useRef();

  const onLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
  }, []);

  const onRenderSuccess = useCallback(() => {
    if (canvasRef?.current) {
      canvasRef.current.style.margin = 0;
      setDimensions({
        height: canvasRef.current.height + 150,
        width: canvasRef.current.width,
      });
    }
  }, []);

  return (
    <Popup
      style={{ padding: 0 }}
      width={dimensions.width}
      height={dimensions.height}
      visible={!!pdfUrl}
      closeOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title="Report"
      container=".dx-viewport"
    >
      {pdfUrl && (
        <Document file={pdfUrl} onLoadSuccess={onLoadSuccess}>
          <Page
            scale={1.12}
            onRenderSuccess={onRenderSuccess}
            canvasRef={canvasRef}
            pageNumber={pageNumber}
          />
        </Document>
      )}
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "close",
          text: "Close",
          onClick: () => dispatch(setUIProperty({ name: "pdfUrl", value: "" })),
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "arrowleft",
          text: "Previous",
          disabled: pageNumber === 1,
          onClick: () => setPageNumber((prev) => prev - 1),
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "arrowright",
          text: "Next",
          disabled: pageNumber === numPages,
          onClick: () => setPageNumber((prev) => prev + 1),
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "download",
          text: "Download",
          onClick: () => downloadPdf(pdfUrl, fileName),
        }}
      />
    </Popup>
  );
};

export default PdfModal;
